import { Head } from 'vite-react-ssg';
import { Container, Heading, Section, Text, buttonClasses } from '@nexa/ui';
import { HTML_LANG } from '@nexa/content';
import { useCopy, useLocale } from '@/core/i18n';
import { PageLink } from '@/core/layout';

/**
 * Trang 404. KHÔNG dùng `<PageHead>` vì trang này không có mục trong bảng route, nên cũng không
 * có canonical hay hreflang — và không nên có: một trang không tồn tại thì không có bản dịch.
 *
 * `noindex` là bắt buộc. Bản tĩnh này được nginx trả kèm mã HTTP 404 thật
 * (`error_page 404 /404/index.html`), không phải 200 — trả 200 cho trang lỗi là "soft 404",
 * Google phát hiện và trừ điểm chất lượng cả site.
 */
export default function NotFoundPage() {
  const copy = useCopy();
  const locale = useLocale();

  return (
    <>
      <Head>
        <html lang={HTML_LANG[locale]} />
        <title>{copy.notFound.title}</title>
        <meta name="robots" content="noindex, follow" />
      </Head>

      <Section size="lg">
        <Container width="prose" className="space-y-6 text-center">
          <Heading level={1}>{copy.notFound.heading}</Heading>
          <Text size="lead" tone="muted">
            {copy.notFound.body}
          </Text>
          <PageLink page="home" className={buttonClasses('primary', 'lg')}>
            {copy.notFound.backHome}
          </PageLink>
        </Container>
      </Section>
    </>
  );
}
